export default {
      id: "micOff-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#micOff-usage",
      toString: function () {
        return this.url;
      }
    }